import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import Icon from './Icon';
import { translate } from './Translate';
import { TranslationStore, AccessibilityStore } from '../stores';
import { Theme } from '../models/Theme';

const Input = styled<any, any>('input', 'input', 'filterSearch')`
    flex: 1;
    border: none;
    outline: none;
    font: inherit;
    background-color: transparent;
    overflow: hidden;
    &::-ms-clear {
        display: none;
    }
`;

const SearchInput = styled<any, any>('div', 'searchInput', 'filterSearch')`
    ${propStyles};
`;

SearchInput.defaultProps = {
    display: 'flex',
    flex: '1 0 auto',
    fontSize: 'inherit',
    fontFamily: 'body',
    fontWeight: 'normal',
    paddingX: 'sm',
    paddingY: 'sm',
    marginY: 'sm',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
};

const ClearSearch = styled<any, any>('button', 'clearSearch', 'filterSearch')`
    ${propStyles};
    cursor: pointer;
    outline: none;
`;

ClearSearch.defaultProps = {
    color: 'inherit',
    bgColor: 'transparent',
    borderStyle: 'none',
};

const ClearIcon = styled<any, any>(Icon, 'clearIcon', 'filterSearch')``;

ClearIcon.defaultProps = {
    cursor: 'pointer',
    height: '1em',
    width: '1em',
};

interface FilterSearchProps {
    theme?: Theme;
    id?: string;
    translationStore?: TranslationStore;
    accessibilityStore?: AccessibilityStore;
    type?: string;
    placeholder?: string;
    value?: string;
    onChange?: () => void;
    onClear?: () => void;
    showClear?: boolean;
}

@inject('translationStore')
@inject('accessibilityStore')
@observer
class FilterSearch extends React.Component<FilterSearchProps> {
    render() {
        const {
            id,
            theme,
            translationStore,
            accessibilityStore,
            placeholder,
            value,
            onChange,
            onClear,
            showClear,
            ...props
        } = this.props;
        return (
            <SearchInput {...theme.FilterSearch} {...props}>
                <Input
                    id={id}
                    type="text"
                    autoCapitalize="off"
                    autoComplete="off"
                    spellCheck="false"
                    autoCorrect="off"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    data-metric-id={'filterSearch'}
                />
                {showClear && (
                    <ClearSearch
                        aria-label={accessibilityStore.buttonAccessibilityValue(
                            'ClearSearch'
                        )}
                        title={translate(translationStore, 'Clear Search')}
                        onClick={onClear}
                        data-metric-id={'filterSearch-clear'}
                    >
                        <ClearIcon fileName="CloseIcon" />
                    </ClearSearch>
                )}
            </SearchInput>
        );
    }
}

export default withTheme(FilterSearch) as any;



// WEBPACK FOOTER //
// ./src/Components/FilterSearch.tsx